const DOC_STATUS_OPTIONS = ["Approved", "Under Review", "Unreviewed"];
const DOC_STATUS_FILTER_ALL = "All";
const DOC_STATUS_FILTER_OPTIONS = [DOC_STATUS_FILTER_ALL, ...DOC_STATUS_OPTIONS];
const DEFAULT_DOC_STATUS = "Unreviewed";

const DOC_STATUS_DATASET_KEYS = new Set([
  "company",
  "google_patents",
  "fda_pma",
  "fda_drugs",
  "fda_denovo",
  "fda_510k",
  "pubmed",
  "clinical_trials",
]);

const normalizeStatusToken = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

const normalizeDocStatusValue = (value) => {
  const token = normalizeStatusToken(value);

  if (!token) {
    return DEFAULT_DOC_STATUS;
  }

  if (token === "approved") {
    return "Approved";
  }

  if (token === "under review") {
    return "Under Review";
  }

  if (token === "unreviewed" || token === "un reviewed") {
    return "Unreviewed";
  }

  return DEFAULT_DOC_STATUS;
};

const normalizeDocStatusFilterValue = (value) => {
  const token = normalizeStatusToken(value);

  if (!token || token === "all") {
    return DOC_STATUS_FILTER_ALL;
  }

  if (DOC_STATUS_OPTIONS.some((option) => normalizeStatusToken(option) === token)) {
    return DOC_STATUS_OPTIONS.find((option) => normalizeStatusToken(option) === token);
  }

  return DOC_STATUS_FILTER_ALL;
};

const getDocStatusBadgeClassName = (value) => {
  const normalizedValue = normalizeDocStatusValue(value);

  if (normalizedValue === "Approved") {
    return "border border-emerald-400/30 bg-emerald-500/10 text-emerald-100";
  }

  if (normalizedValue === "Under Review") {
    return "border border-amber-400/30 bg-amber-500/10 text-amber-100";
  }

  return "border border-rose-400/30 bg-rose-500/10 text-rose-100";
};

const shouldShowDocStatusFeature = (datasetKey) => DOC_STATUS_DATASET_KEYS.has(datasetKey);

export {
  DEFAULT_DOC_STATUS,
  DOC_STATUS_FILTER_ALL,
  DOC_STATUS_FILTER_OPTIONS,
  DOC_STATUS_DATASET_KEYS,
  DOC_STATUS_OPTIONS,
  getDocStatusBadgeClassName,
  normalizeDocStatusValue,
  normalizeDocStatusFilterValue,
  shouldShowDocStatusFeature,
};
